import { getAppId, storeAppId } from './cookies'

export enum AppWhiteLabelId {
  HYUNDAI = 'HYUNDAI',
  GENESIS = 'GENESIS',
  HONDA = 'HONDA',
  ACURA = 'ACURA',
  TOYOTA = 'TOYOTA',
  HERTZ = 'HERTZ',
  CUSTOM = 'CUSTOM',
  BLUESKYNM = 'BLUESKYNM',
  GMC = 'GMC',
  BUICK = 'BUICK',
  ONSTAR = 'ONSTAR',
  CHEVROLET = 'CHEVROLET',
  CADILLAC = 'CADILLAC',
  MAZDA = 'MAZDA',
  INFINITI = 'INFINITI',
  NISSAN = 'NISSAN',
}

export const OEMLogoData = {
  [AppWhiteLabelId.HYUNDAI]: {
    width: {
      xsmall: '50',
      small: '120',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.HYUNDAI.toLowerCase()}-logo`,
    fileName: {
      default: 'hyundai_logo.png',
      xsmall: 'hyundai_logo.svg',
    },
    alt: AppWhiteLabelId.HYUNDAI,
  },
  [AppWhiteLabelId.GENESIS]: {
    width: {
      xsmall: '70',
      small: '120',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.GENESIS.toLowerCase()}-logo`,
    fileName: {
      default: 'genesis_logo.png',
    },
    alt: AppWhiteLabelId.GENESIS,
  },
  [AppWhiteLabelId.HONDA]: {
    width: {
      xsmall: '30',
      small: '35',
      medium: '90',
      large: '130',
    },
    className: `${AppWhiteLabelId.HONDA.toLowerCase()}-logo`,
    fileName: {
      default: 'honda_logo_stacked.svg',
      small: 'honda_logo.svg',
      xsmall: 'honda_logo.svg',
    },
    alt: AppWhiteLabelId.HONDA,
  },
  [AppWhiteLabelId.ACURA]: {
    width: {
      xsmall: '30',
      small: '35',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.ACURA.toLowerCase()}-logo`,
    fileName: {
      default: 'acura_logo.svg',
      small: 'acura_logo_image.svg',
      xsmall: 'acura_logo_image.svg',
    },
    alt: AppWhiteLabelId.ACURA,
  },
  [AppWhiteLabelId.BLUESKYNM]: {
    width: {
      xsmall: '55',
      small: '55',
      medium: '75',
      large: '100',
    },
    className: `${AppWhiteLabelId.BLUESKYNM.toLowerCase()}-logo`,
    fileName: {
      default: 'blueskynm_logo.png',
    },
    alt: AppWhiteLabelId.BLUESKYNM,
  },
  [AppWhiteLabelId.GMC]: {
    width: {
      xsmall: '70',
      small: '120',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.GMC.toLowerCase()}-logo`,
    fileName: {
      default: 'gmc_logo.png',
    },
    alt: AppWhiteLabelId.GMC,
  },
  [AppWhiteLabelId.BUICK]: {
    width: {
      xsmall: '70',
      small: '120',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.BUICK.toLowerCase()}-logo`,
    fileName: {
      default: 'buick_logo.png',
    },
    alt: AppWhiteLabelId.BUICK,
  },
  [AppWhiteLabelId.ONSTAR]: {
    width: {
      xsmall: '40',
      small: '40',
      medium: '60',
      large: '80',
    },
    className: `${AppWhiteLabelId.ONSTAR.toLowerCase()}-logo`,
    fileName: {
      default: 'onstar_logo.svg',
    },
    alt: AppWhiteLabelId.ONSTAR,
  },
  [AppWhiteLabelId.CHEVROLET]: {
    width: {
      xsmall: '70',
      small: '100',
      medium: '135',
      large: '170',
    },
    className: `${AppWhiteLabelId.CHEVROLET.toLowerCase()}-logo`,
    fileName: {
      default: 'chevrolet_logo.png',
    },
    alt: AppWhiteLabelId.CHEVROLET,
  },
  [AppWhiteLabelId.CADILLAC]: {
    width: {
      xsmall: '70',
      small: '100',
      medium: '135',
      large: '170',
    },
    className: `${AppWhiteLabelId.CHEVROLET.toLowerCase()}-logo`,
    fileName: {
      large: 'cadillac_crest_logo.svg',
      medium: 'cadillac_crest_logo.svg',
      default: 'cadillac_logo.svg',
    },
    alt: AppWhiteLabelId.CADILLAC,
  },
  [AppWhiteLabelId.MAZDA]: {
    width: {
      xsmall: '40',
      small: '40',
      medium: '60',
      large: '80',
    },
    className: `${AppWhiteLabelId.MAZDA.toLowerCase()}-logo`,
    fileName: {
      default: 'mazda_logo.png',
    },
    alt: AppWhiteLabelId.MAZDA,
  },
  [AppWhiteLabelId.INFINITI]: {
    width: {
      xsmall: '70',
      small: '120',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.INFINITI.toLowerCase()}-logo`,
    fileName: {
      default: 'infiniti_logo.png',
      xsmall: 'infiniti_logo.svg',
    },
    alt: AppWhiteLabelId.INFINITI,
  },
  [AppWhiteLabelId.NISSAN]: {
    width: {
      xsmall: '45',
      small: '120',
      medium: '160',
      large: '200',
    },
    className: `${AppWhiteLabelId.NISSAN.toLowerCase()}-logo`,
    fileName: {
      default: 'nissan_logo.png',
      xsmall: 'nissan_logo.svg',
    },
    alt: AppWhiteLabelId.NISSAN,
  },
}

export const getRapAppId = (): string => {
  let rapAppId: string
  const appId = getAppId()
  if (appId && appId.toUpperCase() in AppWhiteLabelId) {
    rapAppId = appId.toUpperCase()
  }
  return rapAppId
}

function handleRapAppId() {
  const path = window.location.pathname;
  const rapMatch = path?.match(/\/rap\/([^\/]+)/);
  if (rapMatch) {
    const appId = rapMatch[1].toUpperCase();
    storeAppId(appId);
  }
  
  const rapAppId = getRapAppId();
  const isRapDomain = window.location.href.indexOf("responseroadservice.com") > -1
  if(!rapAppId && isRapDomain) {
    window.location.href = "assets/pages/invalid-url.html"
    throw Error("This is a RAP Build and doesn't allow non RAP users.")
  }

  return rapAppId;
}

function insertManifest(rapAppId: string) {
  const elements = document.getElementsByTagName('link')[ 0 ];
  const insertedLink = document.createElement('link');

  insertedLink.href = rapAppId ? 'manifest.rap.webmanifest' : 'manifest.webmanifest';
  insertedLink.rel = 'manifest'
  elements.parentNode.insertBefore(insertedLink, elements);
}

function insertRapStyle(rapAppId: string) {
  if (rapAppId) {
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `../../assets/drrweb-lib/styles/branding/${rapAppId.toLowerCase()}.css`;

    document.getElementsByTagName('head')[0].appendChild(link);
  }
}

function insertFavicon(rapAppId: string) {
  let faviconName = 'favicon-aaa';
  if (rapAppId) {
    faviconName = 'favicon-' + rapAppId.toLowerCase();
  }
  let link = document.createElement('link');
  link.rel = 'icon';
  link.href = faviconName + '.ico';
  document.getElementsByTagName('head')[0].appendChild(link);
}

function removeMetaTags(rapAppId: string) {
  if (rapAppId) {
    const metaTags = document.querySelectorAll('meta[name="description"],meta[name="keywords"]');
    metaTags.forEach(function(element) {
      element.remove();
    })
  }
}

export const setUpBranding = () => {
  const rapAppId = handleRapAppId();
  insertRapStyle(rapAppId);
  insertFavicon(rapAppId);
  removeMetaTags(rapAppId);
  insertManifest(rapAppId);
}
